import React from "react";

const NotFound: React.FC = () => {
  return (
    <div>
      <h1>We are working on it.</h1>
    </div>
  );
};

export default NotFound;